module.exports = __webpack_public_path__ + "static/media/ocrit-bg.52e07054.jpg";